import './footer.css'

const Footer=()=>{
    return(
        <footer>
            <p className='dev'>
                ©2023 Copyright By Mr.Arofat Sabuding. All rights reserved. | tel. 0902099333
            </p>
        </footer>
    )
}
export default Footer;

